import React from "react";

const items = [
    "Restaurants",
    "Bars & Lounges",
    "Breweries",
    "Cafés",
    "Wine Clubs",
    "Tasting Rooms",
    "Hospitality Groups",
];

export default function Marquee() {
    const doubled = [...items, ...items];
    return (
        <section
            data-testid="marquee-section"
            className="bg-brand-dark text-brand-cream py-6 border-y border-brand-border-dark overflow-hidden"
        >
            <div className="flex whitespace-nowrap marquee-track">
                {doubled.map((it, i) => (
                    <div key={`${it}-${i < items.length ? "a" : "b"}`} className="flex items-center gap-8 px-8">
                        <span className="font-serif italic text-2xl md:text-3xl">{it}</span>
                        <span className="text-brand-orange text-2xl">✦</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
